export const FRONT_LEFT = 'fl'
export const FRONT_RIGHT = 'fr'
export const REAR_LEFT = 'rl'
export const REAR_RIGHT = 'rr'

export const tyreLocations = [
  { key: FRONT_LEFT, label: 'Front Left' },
  { key: FRONT_RIGHT, label: 'Front Right' },
  { key: REAR_LEFT, label: 'Rear Left' },
  { key: REAR_RIGHT, label: 'Rear Right' },
]

export const tyreLocationsObject = Object.fromEntries(
  tyreLocations.map(({ key, label }) => [key, label])
)

export const tyreLocationLabels = {
  [FRONT_LEFT]: 'Front Left',
  [FRONT_RIGHT]: 'Front Right',
  [REAR_LEFT]: 'Rear Left',
  [REAR_RIGHT]: 'Rear Right',
}

export const tyreClaimLocations = [FRONT_LEFT, FRONT_RIGHT, REAR_LEFT, REAR_RIGHT]
